<template>
  <div class="v-select">
    <VInput
      type="text"
      :value="selectText"
      :tmp="selected[label]"
      :placeholder="placeholder"
      :label="label_inp"
      autocomplete="auto-off"
      role="combobox"
      @input="handleInput"
      @blur="handleBlur"
      @mousedown.native="toggleDropdown($event)"
    >
      <template #append-icon>
        <div class="vs__arrow-ico">
          <svg
            width="14px"
            height="9px"
            enable-background="new 0 0 14 9"
            viewBox="0 0 14 9"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clip-rule="evenodd"
              d="m.3 1.4 1.4-1.4 5.3 5.3 5.3-5.3 1.4 1.4-6.7 6.7z"
              fill="#b2b2b2"
              fill-rule="evenodd"
            />
          </svg>
        </div>
      </template>
    </VInput>
    <transition name="vs__fade">
      <div v-if="dropdownOpen">
        <div class="vs__dropdown-menu-border" />
        <ul
          :id="`vs${uid}__listbox`"
          ref="dropdownMenu"
          class="vs__dropdown-menu"
          role="listbox"
          @mousedown.prevent="onMousedown"
          @mouseup="onMouseUp"
        >
          <li
            v-for="(option, index) in filteredOptions"
            :id="`vs${uid}__option-${index}`"
            :key="getOptionKey(option)"
            role="option"
            class="vs__dropdown-option"
            :class="{
              'vs__dropdown-option--selected': isOptionSelected(option),
              'vs__dropdown-option--highlight': index === typeAheadPointer,
            }"
            :aria-selected="index === typeAheadPointer ? true : null"
            @mouseover="selectable(option) ? (typeAheadPointer = index) : null"
            @mousedown.prevent.stop="selectable(option) ? select(option) : null"
          >
            <slot name="option" v-bind="option">
              {{ getOptionLabel(option) }}
            </slot>
          </li>
          <li v-if="filteredOptions.length === 0" class="vs__no-options">
            <slot name="no-options" />
          </li>
        </ul>
      </div>
      <ul v-else :id="`vs${uid}__listbox`" role="listbox" style="display: none; visibility: hidden" />
    </transition>
  </div>
</template>
<script>
import VInput from './VInput.vue';
import {uuid} from 'UTILS';
import './css/v-select.css';
export default {
  name: 'VSelect',
  components: {
    VInput,
  },
  props: {
    value: {
      type: [String, Number],
    },
    isSelected: {
      type: [Object, String, Number],
    },
    options: {
      type: Array,
    },
    label: {
      type: String,
    },
    label_inp: {
      type: String,
    },
    reduce: {
      type: Function,
    },
    maxHeight: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    searchFn: {
      type: Function,
    },
  },
  data() {
    return {
      selected: {},
      dropdownOpen: false,
      uid: '',
      filteredOptions: [],
      typeAheadPointer: '',
      selectText: '',
    };
  },
  watch: {
    value(val) {
      if (!val || val === '') {
        this.selected = {};
        this.setSelectText('');
        this.filteredOptions = this.options;
      } else {
        this.setSelectText(this.selected[this.label]);
      }
    },
    options: {
      handler(val) {
        this.filteredOptions = val;
      },
      deep: true,
    },
  },
  created() {
    this.uid = uuid();
    this.filteredOptions = this.options;
    if (this.isSelected) {
      this.select(this.isSelected);
    }
  },
  methods: {
    handleBlur(ev) {
      this.dropdownOpen = false;
      if (this.selected[this.label]) {
        this.setSelectText(this.selected[this.label]);
      } else {
        this.setSelectText('');
      }
      this.filteredOptions = this.options;
    },
    onMousedown() {},
    onMouseUp() {},
    getOptionKey(option) {},
    isOptionSelected(option) {
      if (option[this.label] === this.selected[this.label]) {
        return true;
      }
      return false;
    },
    getOptionLabel(option) {
      return option[this.label];
    },
    selectable() {
      return true;
    },
    select(option) {
      this.selected = option;
      this.setSelectText(option[this.label]);
      this.dropdownOpen = false;
      this.$emit('select', this.selected);
      const newVal = this.reduce(option);
      this.$emit('input', newVal);
      this.filteredOptions = this.options;
    },
    handleInput(ev) {
      this.selected = {};
      this.$emit('input', '');
      if (this.searchFn) {
        this.searchFn(ev);
      } else {
        this.filteredOptions = this.filterOptions(this.options, ev);
      }
      this.dropdownOpen = true;
      this.setSelectText(ev);
    },
    filterOptions(options, str) {
      if (str) {
        str = str.toLowerCase();
        return options.filter((el) => {
          const label = el[this.label].toLowerCase();
          return label.indexOf(str) + 1;
        });
      }
      return options;
    },
    setSelectText(ev) {
      this.selectText = ev;
    },
    toggleDropdown(ev) {
      this.setSelectText('');
      const ignoredButtons = [...(this.$refs['deselectButtons'] || []), ...([this.$refs['clearButton']] || [])];
      this.dropdownOpen = true;
    },
  },
};
</script>
<style scoped></style>
